var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("v-simple-table", {
        attrs: {
          "fixed-header": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c("thead", [
                  _c(
                    "tr",
                    {
                      staticClass: "bg-dark",
                    },
                    [
                      _c(
                        "th",
                        {
                          staticClass: "bg-dark text-center text-light",
                        },
                        [_vm._v("ประเภท")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "bg-dark text-center text-light",
                        },
                        [_vm._v("เลขแทง")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "bg-dark text-center text-light",
                        },
                        [_vm._v("ยอดแทง")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "bg-dark text-center text-light",
                        },
                        [_vm._v("ยอดถูก")]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.numberTop, function (item, index) {
                    return _c(
                      "tr",
                      {
                        key: item.id,
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                          },
                          [
                            item.slug === "any_upper"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "success",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.constants[item.slug]) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : item.slug === "any_under"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "warning",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.constants[item.slug]) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : item.slug === "2upper"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "primary",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.constants[item.slug]) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : item.slug === "2under"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "red lighten-2",
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.constants[item.slug]) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : item.slug === "3upper"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "pink darken-1",
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.constants[item.slug]) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : item.slug === "3shuffle"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "danger",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.constants[item.slug]) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : item.slug === "3front"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "blue-grey",
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.constants[item.slug]) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : item.slug === "3back"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "brown",
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.constants[item.slug]) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.digits) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-monospace text-center text-success d-block",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    Intl.NumberFormat("en-US").format(
                                      item.amount
                                    )
                                  )
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-monospace text-center text-success d-block",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  Intl.NumberFormat("en-US").format(item.prize)
                                )
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            width: "500",
            "max-width": "100vw",
          },
          model: {
            value: _vm.preload,
            callback: function ($$v) {
              _vm.preload = $$v
            },
            expression: "preload",
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "pa-md-10 mx-lg-auto",
            },
            [
              _c(
                "v-container",
                {
                  staticClass: "text-center",
                },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      size: 100,
                      width: 10,
                      indeterminate: "",
                      color: "primary",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }